import * as React from 'react';

import {colors} from '../../../colors/colors';
import type {ColorName} from '../../../colors/colors';

import styles from './tokenized-item-wrapper.module.css';

type Props = {
    children: React.ReactNode | null | undefined;
    colorName?: ColorName;
};

export function TokenizedItemWrapper(props: Props) {
    return (
        <div className={styles['tokenized-wrapper']}>
            <span
                style={props.colorName && {backgroundColor: colors[props.colorName]}}
                className={styles['tokenized-content']}
            >
                {props.children}
            </span>
        </div>
    );
}
